"use client";

import Intercom from "@intercom/messenger-js-sdk";

export const IntercomWidget = () => {
  Intercom({
    app_id: "q4275y4h",
  });

  return null;
};
